<template>
<div class="editor">
	
	<div v-if="page_loaded == 1" class="row">
		
		<div class="col-md-8">
			<div class="card">
				
				<h4 class="card-header">Compose Email</h4>
				
				<div class="card-body">
					
					<div v-if="show_title" class="row">
						<div class="col-12">
							<input 
								v-model="subject" 
								placeholder="Enter Subject/Title"
								class="form-control form-control-lg"
							/>
						</div>
					</div>

					<editor-menu-bar v-if="editor_type === 'default'" :editor="editor" v-slot="{ commands, isActive }">
						<div 
							class="menubar"
						>
					
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.bold() }"
							@click="commands.bold"
						>
						<i class="fas fa-bold"></i>
						</button>
					
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.italic() }"
							@click="commands.italic"
						>
						<i class="fas fa-italic"></i>
						</button>
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.underline() }"
							@click="commands.underline"
						>
						<i class="fas fa-underline"></i>
						</button>
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.paragraph() }"
							@click="commands.paragraph"
						>
						<i class="fas fa-paragraph"></i>
						</button>
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.heading({ level: 1 }) }"
							@click="commands.heading({ level: 1 })"
						>
						H1
						</button>
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.heading({ level: 2 }) }"
							@click="commands.heading({ level: 2 })"
						>
						H2
						</button>
						
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.bullet_list() }"
							@click="commands.bullet_list"
						>
						<i class="fas fa-list-ul"></i>
						</button>
						
						<button
							class="btn text-link"
							:class="{ 'is-active': isActive.ordered_list() }"
							@click="commands.ordered_list"
						>
						<i class="fas fa-list-ol"></i>
						</button>
					
						
						<button
							class="btn text-link"
							@click="commands.horizontal_rule"
						>
						<i class="far fa-window-minimize"></i>
						</button>
						
						<button
							class="btn text-link"
							@click="commands.undo"
						>
						<i class="fas fa-undo"></i>
						</button>
						
						<button
							class="btn text-link"
							@click="commands.redo"
						>
						<i class="fas fa-redo"></i>
						</button>
					
					</div>
					</editor-menu-bar>


					<editor-content class="editor__content" :editor="editor" />
					
				</div>
				
			</div>
		</div>
		
		<div class="col-md-4">
			<div class="card">
				
				<h4 class="card-header">Send to Members</h4>
				
				<div class="card-body">
				
					<button v-if="members.length == 0" @click="membersGet" class="btn btn-outline-primary">
						<i class="fas fa-users"></i> Load Members
					</button>
					
					<div v-else>
						
						<b-form-checkbox v-model="members_select_all" button button-variant="outline-secondary" class="btn-block mb-3">
						<span v-if="members_select_all === true">
							Deselect All Members (<b v-text="members.length"></b>)
						</span>
						<span v-else>
							Select All Members (<b v-text="members.length"></b>)
						</span>
						</b-form-checkbox>
						
						
						<b-form-group class="member_list">
							<b-form-checkbox-group
								v-model="members_selected"
								:options="members"
								button-variant="secondary"
								buttons
								stacked
								size="sm"
								name="members"
							>
							</b-form-checkbox-group>
						</b-form-group>
						
						
						<b-form-checkbox v-model="members_select_all" button button-variant="outline-secondary" class="btn-block mb-3">
						<span v-if="members_select_all === true">
							Deselect All Members (<b v-text="members.length"></b>)
						</span>
						<span v-else>
							Select All Members (<b v-text="members.length"></b>)
						</span>
						</b-form-checkbox>
						
						<button 
							class="btn btn-success"
							@click="sendEmail"
							:disabled="!members_selected.length > 0"
						><i class="far fa-paper-plane"></i> Send - selected (<span v-text="members_selected.length"></span>)</button>
						
						
						<b-alert 
							:variant="result.class" 
							:show="dismissCountDown"
							dismissible
							v-text="result.message"
							@dismissed="dismissCountDown=0"
							@dismiss-count-down="countDownChanged"
						>
						</b-alert>
						
						
					</div>
					
				</div>
				
			</div>
		</div>
		
	</div>
	
	<div v-else class="text-center gold mt-5 pt-5">
		<img src="process.env.VUE_APP_LOGO" alt="iAMc" width="auto" height="35" class="m-4" /><br />
		<i class="fas fa-atom fa-spin fa-2x"></i>
	</div>
 
</div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import axios from "axios";

import {
	Blockquote,
	CodeBlock,
	HardBreak,
	Heading,
	HorizontalRule,
	OrderedList,
	BulletList,
	ListItem,
	TodoItem,
	TodoList,
	Bold,
	Code,
	Italic,
	Link,
	Strike,
	Underline,
	History,
} from 'tiptap-extensions';

export default {
	name: 'TipTapEditor',
	components: {
		EditorContent,
		EditorMenuBar,
	},
	props: {
		editor_type: {
			type: String,
			default: 'default',
		},
		show_title: {
			type: Boolean,
			default: true,
		},
	},
	mounted: function() {
		this.membersGet();
	},
	computed: {
		session_id(){
			var session_id = this.$store.state.session_id;
			return session_id;
		}
	},
	data() {
		return {
			dismissSecs: 3,
			dismissCountDown: 0,
			showDismissibleAlert: false,
			editor: new Editor({
				extensions: [
					new Blockquote(),
					new BulletList(),
					new CodeBlock(),
					new HardBreak(),
					new Heading({ levels: [1, 2, 3] }),
					new HorizontalRule(),
					new ListItem(),
					new OrderedList(),
					new TodoItem(),
					new TodoList(),
					new Link(),
					new Bold(),
					new Code(),
					new Italic(),
					new Strike(),
					new Underline(),
					new History(),
				],
				content: '',
				onUpdate: ({ getHTML }) => {
					this.html = getHTML()
				},
			}),
			html: '',
			page_loaded: 0,
			subject: '',
			result: {
				message: '',
				class: '',
				status: 0,
			},
			members: [],
			members_selected: [],
			members_select_all: false,
		};
	},
	beforeDestroy(){
		this.editor.destroy();
	},
	watch: {
		members_select_all(val){
			this.members_selected = [];
			if(val == true){
				for(const member of this.members){
					this.members_selected.push(member.value);
				}
			}
		},
		members(val){
			if(val.length > 0) this.page_loaded = 1;
		}
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		membersGet(){
			console.log('membersGet');
			let _this = this;
			_this.members = [];
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + "membersGetList",
				params: params,

			}).then(function (response) {
				
				if(response.data.members){
					const items = Object.values(response.data.members);
					for(const member of items){
						_this.members.push(
							{
								text: member.first_name + " " + member.last_name + ": " + member.email,
								value: member.id
							}
						)
					}
				}
				
			}).catch(function (error) {
				console.log(error);
			});
			
		},
		sendEmail(){
			let _this = this;
			
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('html', _this.html);
			params.append('members', _this.members_selected);
			
			if(_this.show_title == true){
				params.append('subject', _this.subject);
			}

			axios({
				url: _this.$store.state.api_url + "emailsSend",
				params: params,

			}).then(function (response) {
				
				_this.result.status = response.data.status;
				_this.result.message = response.data.message;
				_this.result.class = response.data.class;
				_this.showDismissibleAlert = true;
				_this.dismissCountDown = _this.dismissSecs;
				
				if(parseInt(response.data.status) === 1){
					_this.html = '';
					_this.subject = '';
					_this.editor.clearContent();
				}
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
	},
};
</script>

<style>
.editor__content {
	border: 2px dashed rgba(204, 204, 204, 0.3);
	padding: 5px;
	margin:0;
}
.editor__content p {
	padding: 0;
	margin: 0;
}
.editor__content .ProseMirror {
	padding: 10px;
}
.member_list .btn {
	text-align: left;
}
.btn-secondary.active {
	color: #FFF !important;
    background-color: #d1af60 !important;
    border-color: #FFF !important;
}
</style>